import { createTheme } from '@mui/material/styles';
import { BLUE, BLUE_HOVER, BLUE_PRESSED, BLUE_TEXT, BORDER, ERROR, ERROR_SOFT, ERROR_TEXT, GREEN, INK, PAGE_BACKGROUND, SLATE, SOFT_BLUE, SUCCESS_SOFT, SUCCESS_TEXT, WARNING, WARNING_SOFT, WARNING_TEXT, YELLOW } from './mockupPalette';

// The mockups intentionally use one visual system. Screen-specific files may still
// choose Poppins for headings, but controls and unstyled MUI text inherit Inter.
const mockupTheme = createTheme({
    palette: {
        primary: { main: BLUE, dark: BLUE_PRESSED },
        secondary: { main: YELLOW, contrastText: INK },
        success: { main: GREEN, dark: SUCCESS_TEXT, light: SUCCESS_SOFT },
        error: { main: ERROR, dark: ERROR_TEXT, light: ERROR_SOFT },
        warning: { main: WARNING, dark: WARNING_TEXT, light: WARNING_SOFT },
        info: { main: BLUE, dark: BLUE_TEXT, light: SOFT_BLUE },
        text: { primary: INK, secondary: SLATE },
        background: { default: PAGE_BACKGROUND, paper: '#FFFFFF' },
        divider: BORDER,
    },
    shape: { borderRadius: 11 },
    typography: {
        fontFamily: 'Inter, sans-serif',
        button: { fontFamily: 'Inter, sans-serif', fontWeight: 700, textTransform: 'none' },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 11,
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' },
                },
                sizeMedium: {
                    minHeight: 44,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: { fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: { fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: { fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: { fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: { minHeight: 44, fontFamily: 'Inter, sans-serif' },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: { minHeight: 44, fontFamily: 'Inter, sans-serif', textTransform: 'none' },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    minHeight: 44,
                    borderRadius: 11,
                    fontFamily: 'Inter, sans-serif',
                    textTransform: 'none',
                    '&.Mui-selected': {
                        color: BLUE_TEXT,
                        backgroundColor: SOFT_BLUE,
                        '&:hover': { backgroundColor: BLUE_HOVER },
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: { borderRadius: 11 },
            },
        },
        // Same Alert colors as the production theme: the documented soft/text pairs.
        MuiAlert: {
            styleOverrides: {
                standardSuccess: { backgroundColor: SUCCESS_SOFT, color: SUCCESS_TEXT, '& .MuiAlert-icon': { color: GREEN } },
                standardError: { backgroundColor: ERROR_SOFT, color: ERROR_TEXT, '& .MuiAlert-icon': { color: ERROR_TEXT } },
                standardWarning: { backgroundColor: WARNING_SOFT, color: WARNING_TEXT, '& .MuiAlert-icon': { color: WARNING_TEXT } },
                standardInfo: { backgroundColor: SOFT_BLUE, color: BLUE_TEXT, '& .MuiAlert-icon': { color: BLUE } },
            },
        },
    },
});

export default mockupTheme;
